'use client'

import { BlokProps } from '@/lib/types'
import { VideoStoryblok } from '@/lib/types/component-types-sb'
import ReactPlayer from 'react-player'

export function VideoEmbed({ blok }: BlokProps<VideoStoryblok>) {
  return (
    <div className="bg-sidebar border-border aspect-video w-full rounded border p-2">
      <ReactPlayer
        width="100%"
        height="100%"
        url={blok.url}
      />
    </div>
  )
}
